// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const tr: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Nasıl Oynanır',
  'howto.pieces.heading': 'Parçalar',
  'howto.pieces.source': 'Kaynak',
  'howto.pieces.mirror': 'Ayna',
  'howto.pieces.switch': 'Anahtar',
  'howto.pieces.exit': 'Çıkış',
  'howto.pieces.wall': 'Duvar',
  'howto.controls.heading': 'Kontroller',
  'howto.controls.clickSlot.line1': 'Yuvaya tıkla',
  'howto.controls.clickSlot.line2': 'ayna yerleştir',
  'howto.controls.dragMirror.line1': 'Aynayı sürükle',
  'howto.controls.dragMirror.line2': 'döndür',
  'howto.controls.rightClick.line1': 'Sağ tık',
  'howto.controls.rightClick.line2': 'aynayı kaldır',
  'howto.controls.hint': 'Fare tekerleği: 1° hassas döndürme.   Aynaya dokunma: 15° döndürme.',
  'howto.objective.line1': 'Her anahtarı yak — çıkış kilidi kendiliğinden açılır.',
  'howto.objective.line2': 'Sonra çıkışa tıkla. Olabildiğince az aynayla çöz.',

  'howtoColor.title': 'Renk ve Prizmalar',
  'howtoColor.pieces.heading': 'Yeni parçalar',
  'howtoColor.pieces.prism': 'Prizma',
  'howtoColor.pieces.redSwitch': 'Kırmızı anahtar',
  'howtoColor.pieces.yellowSwitch': 'Sarı anahtar',
  'howtoColor.pieces.whiteSwitch': 'Beyaz anahtar',
  'howtoColor.how.heading': 'Nasıl çalışırlar',
  'howtoColor.how.line1': 'Beyaz ışın kırmızı, yeşil ve mavi ışığı aynı anda taşır.',
  'howtoColor.how.line2': 'Prizma beyaz ışığı üç kenarı boyunca üç renkli ışına ayırır.',
  'howtoColor.how.line3': 'Yerleştirilmiş prizmaya tıklayarak giriş yüzünün yönünü döndür.',
  'howtoColor.switches.line1': 'Anahtarlar renkli noktalar gösterir — istedikleri renk odur.',
  'howtoColor.switches.line2': 'Sarı anahtar (kırmızı + yeşil noktalar) iki rengi birden ister.',
  'howtoColor.switches.line3': 'Beyaz anahtar (üç renk) kırmızı, yeşil VE maviyi aynı anda ister.',

  'options.hints.label': 'Bulmacalarda ipucu açılarını göster',
  'options.hints.help': 'Her sıçramada gelen ve yansıyan ışın arasındaki açıyı görüntüler.',

  'level.01-intro.title': 'Merhaba Işık',
  'level.02-two-mirrors.title': 'İki Dönüş',
  'level.03-corner.title': 'Yolda Duvar',
  'level.04-two-targets.title': 'İki Hedef',
  'level.05-tight.title': 'Dar',
  'level.06-hello-color.title': 'Merhaba Renk',
  'level.07-pick-a-side.title': 'Bir Taraf Seç',
  'level.08-yellow.title': 'Sarı',
  'level.09-magenta.title': 'Macenta',
  'level.10-spectrum.title': 'Tayf',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'dik',
  'puzzle.hint.angleType.acute': 'dar',
  'puzzle.hint.angleType.obtuse': 'geniş',
  'puzzle.hint.label': '{angle}°\n{type}',
};
